import "./ForgotPassword.scss";
import Logo from "../../../assets/images/logo-color.png";
import { RText, RButton } from "../../../components/Controls";
import Libs from "../../../utils/Libs";
import { NavLink } from "react-router-dom";
import LoginParticles from "../Login/LoginParticles";

export default function ForgotPassword() {
  const { t } = this.props;
  var { curItem, message } = this.state;

  return (
    <div className="forgot-password">
      <div className="main-login">
        <div className="content">
          <div className="main-form">
            <div className="logo">
              <NavLink to="/">
                <img src={Logo} alt="Phần mềm quản lý bán hàng" />
              </NavLink>
            </div>
            <h1>{t("forgot_password.title")}</h1>
            <div className="form">
              {!Libs.isBlank(message) ? (
                <div className="alert-message">
                  <p>
                    <span className="icon-check-circle"></span>
                  </p>
                  <p>{message}</p>
                  <p>
                    <NavLink to="/">{t("common.close")}</NavLink>
                  </p>
                </div>
              ) : (
                <div className="row">
                  <div className="col-xl-12 col-lg-12 col-md-4 col-12">
                    <div className="mb-3">
                      <RText
                        label={t("forgot_password.email")}
                        inputClass="form-control"
                        inputId="email"
                        inputName="email"
                        value={curItem.email}
                        onChange={(e) => {
                          this.handleInputChange(e);
                          this.validateOne(e);
                        }}
                        maxLength={100}
                      />
                    </div>
                  </div>

                  <div className="col-xl-12 col-lg-12 col-md-4 col-12">
                    <RButton
                      onClick={this.onSaveAction.bind(this)}
                      className="btn btn-save"
                      text={t("forgot_password.save")}
                      title={t("forgot_password.save")}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <LoginParticles />
    </div>
  );
}
